// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"81b440a2","455":"11a7f6e6","977":"aaa8b55d"}[chunkId] + ".chunk.js";
};